import { render } from "./ContactGeneric.vue?vue&type=template&id=595b5132"
import script from "./ContactGeneric.vue?vue&type=script&lang=ts"
export * from "./ContactGeneric.vue?vue&type=script&lang=ts"
script.render = render

export default script